import React, {forwardRef} from 'react';

import whiteLabelContextService from '../../services/restServices/whiteLabelContextService';

import whiteLabelConfig from '../../config/whiteLabelConfig';
import VIDABOO_CONSTANTS from '../../config/consts';

import consoltoLogo from '../../assets/svg/consolto-logo.svg';
import utilsService from '../../services/utilsService';

export const WhiteLabelContext = React.createContext();

class WhiteLabelContextProvider extends React.Component {
  constructor() {
    super();
    this.state = {
      isAgencyInfoFetched: false,
    };
  }

  setWhiteLabelDefaultConfig = () => {
    this.setState({
      isAgencyWhiteLabeled: false,
      agencyName: whiteLabelConfig.agencyName,
      agencyDomain: whiteLabelConfig.agencyDomain,
      agencyWebsite: whiteLabelConfig.agencyWebsite,
      agencyContactEmail: whiteLabelConfig.emails.contact,
      agencySupportEmail: whiteLabelConfig.emails.support,
      agencyTerms: whiteLabelConfig.agencyTerms,
      agencyPrivacyPolicy: whiteLabelConfig.agencyPrivacyPolicy,
    });
    this.setDefaultAgencyPhotoDtos();
  };

  setDefaultAgencyPhotoDtos = () => {
    const defaultAgencyPhotoDtos = [
      {
        isDefaultPhoto: true,
        objectType: VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.RESELLERAGENCY,
        photoType: VIDABOO_CONSTANTS.PHOTO_TYPES.BACKGROUND,
        photoUrl: consoltoLogo,
      },
      {
        isDefaultPhoto: true,
        objectType: VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.RESELLERAGENCY,
        photoType: VIDABOO_CONSTANTS.PHOTO_TYPES.FAVICON,
        photoUrl: '/favicon.ico',
      },
      {
        isDefaultPhoto: true,
        objectType: VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.RESELLERAGENCY,
        photoType: VIDABOO_CONSTANTS.PHOTO_TYPES.EMAIL_LOGO,
        photoUrl: consoltoLogo,
      },
    ];
    this.setState({agencyPhotoDtos: defaultAgencyPhotoDtos});
  };

  updateWhiteLabelConfigByResellerAgencyCtrl = (
    resellerAgencyCtrl = {},
    shouldSetIsAgencyInfoFetched = true,
  ) => {
    const mappedData =
      whiteLabelContextService.mapResellerAgencyCtrlToWhiteLabelConfig(
        resellerAgencyCtrl,
        this.state.agencyPhotoDtos,
      );

    this.setState({
      isAgencyInfoFetched: shouldSetIsAgencyInfoFetched ? true : false,
      ...mappedData,
    });
  };

  setIsAgencyInfoFetched = (isAgencyInfoFetched) => {
    this.setState({isAgencyInfoFetched});
  };

  resetWhiteLabelContext = () => {
    if (
      this.state.isAgencyWhiteLabeled &&
      utilsService.getIsInAuthenticationPageOrBackoffice() &&
      window.location.origin === VIDABOO_CONSTANTS.APP_PAGE
    ) {
      this.setWhiteLabelDefaultConfig();
    }
  };

  render() {
    const {
      isAgencyInfoFetched,
      isAgencyWhiteLabeled,
      agencyName,
      agencyDomain,
      agencyWebsite,
      agencyContactEmail,
      agencySupportEmail,
      agencyPhotoDtos,
      agencyTerms,
      agencyPrivacyPolicy,
    } = this.state;
    const {
      resetWhiteLabelContext,
      setIsAgencyInfoFetched,
      setWhiteLabelDefaultConfig,
      updateWhiteLabelConfigByResellerAgencyCtrl,
    } = this;

    return (
      <WhiteLabelContext.Provider
        value={{
          isAgencyInfoFetched,
          isAgencyWhiteLabeled,
          agencyName,
          agencyDomain,
          agencyWebsite,
          agencyContactEmail,
          agencySupportEmail,
          agencyPhotoDtos,
          agencyTerms,
          agencyPrivacyPolicy,
          setIsAgencyInfoFetched,
          setWhiteLabelDefaultConfig,
          updateWhiteLabelConfigByResellerAgencyCtrl,
          resetWhiteLabelContext,
        }}>
        {this.props.children}
      </WhiteLabelContext.Provider>
    );
  }
}

export default WhiteLabelContextProvider;

export const withWhiteLabelContext = (Component) =>
  //eslint-disable-next-line react/display-name
  forwardRef((props, ref) => (
    <WhiteLabelContext.Consumer>
      {(context) => (
        <Component whiteLabelContext={context} {...props} ref={ref} />
      )}
    </WhiteLabelContext.Consumer>
  ));
